import { useEffect, useRef } from 'react'
import { isTimeRange, TimeRangeOrPeriod } from 'src/types'
import {
  ExcludedPeriod as ExcludedPeriodService,
  FetchModel,
} from 'src/services'
import { useTrainingPeriodStore } from './training-period.state'

export function isTrainingPeriodChanged(
  model: FetchModel,
  trainingPeriod: TimeRangeOrPeriod,
): boolean {
  if (isTimeRange(trainingPeriod)) {
    return (
      model.trainingStart?.valueOf() !== trainingPeriod.from ||
      model.trainingEnd?.valueOf() !== trainingPeriod.to
    )
  }
  if (model.trainingPeriod !== trainingPeriod.period) {
    return true
  }
  return false
}

type SyncTrainingPeriodParams = {
  model: FetchModel
}

export function useSyncTrainingPeriod({
  model,
}: SyncTrainingPeriodParams): void {
  const { resetState } = useTrainingPeriodStore()
  const prev = useRef<{
    id: string
    trainingStart?: number
    trainingEnd?: number
    trainingPeriod?: string
    excludedPeriods?: ExcludedPeriodService[]
  }>()

  useEffect(() => {
    const trainingStart = model.trainingStart?.valueOf()
    const trainingEnd = model.trainingEnd?.valueOf()
    const modelTrainingPeriod = model.trainingPeriod
    const excludedPeriods = model.trainingPeriodExclusions

    const hasChanged =
      prev.current?.id !== model.id ||
      prev.current?.trainingStart !== trainingStart ||
      prev.current?.trainingEnd !== trainingEnd ||
      prev.current?.trainingPeriod !== (modelTrainingPeriod ?? undefined) ||
      JSON.stringify(prev.current?.excludedPeriods) !==
        JSON.stringify(excludedPeriods)

    if (hasChanged) {
      resetState({
        id: model.id,
        trainingEnd: model.trainingEnd,
        trainingStart: model.trainingStart,
        trainingPeriod: model.trainingPeriod ?? undefined,
        excludedPeriods: model.trainingPeriodExclusions,
      })
      prev.current = {
        id: model.id,
        trainingStart,
        trainingEnd,
        trainingPeriod: modelTrainingPeriod ?? undefined,
        excludedPeriods,
      }
    }
  }, [
    model.id,
    model.trainingEnd,
    model.trainingPeriod,
    model.trainingPeriodExclusions,
    model.trainingStart,
    resetState,
  ])
}
